import { Component } from '@angular/core';
import { FsnButton } from '@ford-fusion/angular';

@Component({
    selector: 'app-login-failed',
    templateUrl: './login-failed.component.html',
    standalone: true,
    styleUrls: ['./login-failed.component.css'],
    imports: [FsnButton]
})
export class LoginFailedComponent {
    retry(): void {
        window.location.href = '/login';
    }
}
